// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","leftCol":"Footer_leftCol__yn38N","mhrLogo":"Footer_mhrLogo__g0Fj5","arvsfondenLogo":"Footer_arvsfondenLogo__eLFX7"};